import { html } from 'lit';
import { ChevronsRight } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-chevrons-right')
export class PdsIconChevronsRight extends PdsIcon {
  @state()
  icon = ChevronsRight;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
